import React from "react";
import { CircularProgress, Backdrop, Typography } from "@mui/material";

const Loader = ({ loading }) => {
  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        display: "flex",
        flexDirection: "column",
        gap: 2, // Spacing between elements
      }}
      open={loading}
    >
      <CircularProgress color="inherit" />
      <Typography variant="body1" align="center">
        Please don't close the page or refresh while loading...
      </Typography>
    </Backdrop>
  );
};

export default Loader;
